import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, UserService, AuthenticationService } from '../_services/index';
import { Guid } from "guid-typescript";
import { CustomValidators } from '../_helpers/custom-validators';

import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';
@Component({
    selector: 'password',
    //moduleId: module.id,
    templateUrl: 'password.component.html',
    standalone: false
})

export class PasswordComponent implements OnInit {
  model: any = {};
  loading = false;
  enableBtnResend: boolean = false;
  activationCode: string;
  frmSignup: UntypedFormGroup;
  submitted = false;
  returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private successModalHelper: SuccessModalHelperService) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.frmSignup = this.formBuilder.group({
      username: ['', Validators.required],
      password: [null, Validators.compose([
        Validators.required,
        // check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // check whether the entered password has a lower case letter
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // check whether the entered password has a special character
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])
      ],
      confirmPassword: [null, Validators.compose([Validators.required])]
    },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.MustMatch
      });
  }

  get f() { return this.frmSignup.controls; }

  public register(): void {
    // TODO: this method was missing
  }
}
